import { Component, Input } from '@angular/core'
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap"
import { CmmsItemModalComponent } from "../cmms-item-modal/cmms-item-modal.component"

@Component({
  selector: 'app-cmms-item-tooltip',
  templateUrl: './cmms-item-tooltip.component.html',
  styleUrl: './cmms-item-tooltip.component.scss',
  standalone: false,
})
export class CmmsItemTooltipComponent {
  @Input({ required: true }) type: 'NO' | 'WO'
  @Input() items: { name: string; title: string; url: string; status?: number }[] = []
  @Input() openNotificationPopup: boolean = false

  constructor(private modalService: NgbModal) {}

  public onNotificationModalOpen(item: {
    name: string
    title: string
    url: string
    status?: number
  }): void {
    this.items = [] // Close tooltip after opening modal

    const modalRef: NgbModalRef = this.modalService.open(CmmsItemModalComponent, { size: 'md' })
    modalRef.componentInstance.type = 'NO'
    modalRef.componentInstance.item = item
    modalRef.result.then((result) => {}).catch((res) => {})
  }
}
